"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CookieStore_1 = require("../../../Services/Storage/Cookie/Polyfill/CookieStore");
const TypeGuard_1 = require("../../../Types/TypeGuard");
const Assert_1 = require("../../../Utility/Assert");
class CookieStorageEngine {
    constructor(options) {
        var _a;
        this.options = options;
        // If Cookie API is not yet available in browser use the polyfill CookieStore
        if (typeof options.cookieStore === 'undefined' && ('cookieStore' in window) === false) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            window.cookieStore = CookieStore_1.cookieStoreInstance;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            window.CookieStore = CookieStore_1.CookieStore;
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this.cookieStore = ((_a = options.cookieStore) !== null && _a !== void 0 ? _a : window.cookieStore);
    }
    async getValue(identifier) {
        const cookie = await this.cookieStore.get(identifier);
        return cookie === null || cookie === void 0 ? void 0 : cookie.value;
    }
    async setValue(identifier, value = '') {
        if (TypeGuard_1.default.isString(value)) {
            value = {
                name: identifier,
                value
            };
        }
        const options = typeof this.options.default !== 'undefined' ? { ...this.options.default, ...value } : value;
        await this.cookieStore.set(options);
    }
    async remove(identifier) {
        await this.cookieStore.delete(identifier);
    }
    async keys() {
        const cookies = await this.cookieStore.getAll();
        return cookies.map(cookie => Assert_1.default.notUndefined(cookie.name));
    }
    async clear() {
        const cookies = await this.keys();
        await Promise.all(cookies.map(cookie => this.remove(cookie)));
    }
}
exports.default = CookieStorageEngine;
//# sourceMappingURL=CookieStorageEngine.js.map